import { render, staticRenderFns } from "./servicePlan.vue?vue&type=template&id=8ccff9b4&scoped=true&"
import script from "./servicePlan.vue?vue&type=script&lang=js&"
export * from "./servicePlan.vue?vue&type=script&lang=js&"
import style0 from "./servicePlan.vue?vue&type=style&index=0&id=8ccff9b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccff9b4",
  null
  
)

export default component.exports